const filter = {
  NumFormat: function(val, defaultValue) {
    if (typeof val === "number") {
      return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
    return defaultValue || "";
  },
  toDecimal2NoZero: function(val) {
    if (typeof val === "number") {
      return (Math.round(val * 100) / 100)
        .toString()
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
  },
  "yyyy-MM-dd": function(val) {
    if (val) {
      let time = new Date(val.toString().replace(/-/g, "/"));
      if (typeof time === "object") {
        return (
          time.getFullYear() +
          "-" +
          (time.getMonth() + 1) +
          "-" +
          time.getDate()
        );
      }
    }
  },
  textareaToFormat: function(val) {
    if (val && val != "null" && val != "undefined") {
      return val.replace(/\n/g, "</br>");
    } else {
      return val;
    }
  }
};
export default filter;



// WEBPACK FOOTER //
// ./src/utils/filter.js